import { useEffect } from 'react';

/**
 * Calls `open` on Ctrl/Cmd-?, the shortcut that lists every other shortcut.
 *
 * `?` is Shift-/ on most layouts, so the physical key is accepted as well as the character
 * in case a layout reports something else. It works from a field, since holding Ctrl types
 * nothing, but it does not stack on top of a modal that is already open.
 */
export function useShortcutsHelpShortcut(open: () => void): void {
  useEffect(() => {
    function onKey(event: KeyboardEvent) {
      const question = event.key === '?' || (event.code === 'Slash' && event.shiftKey);
      if (!question || !(event.ctrlKey || event.metaKey) || event.altKey) return;
      if (document.querySelector('[role="dialog"]') != null) return;

      event.preventDefault();
      open();
    }

    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
}
